export const validateRipplrEmail = (email) => {
	/* eslint-disable no-useless-escape */
	const RIPPLR_MAIL = '@ripplr.in';
	const emailRegExp =
		/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return !!(
		emailRegExp.test(email) &&
		email.indexOf(RIPPLR_MAIL, email.length - RIPPLR_MAIL.length) !== -1
	);
};

export const validateMobileNumber = (value) => {
	if (!value) {
		return true;
	}
	const phoneRegExp = /^[6-9]\d{9}$/gi;
	return phoneRegExp.test(value);
};
